import React from "react";
import "./App.css";
import SongFinder from "./SongFinder";
import "./tailwind.css";

function App() {
  return (
    <div className="App">
      <SongFinder />
    </div>
  );
}

export default App;
